var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.flag)?_c('div',{staticClass:"all"},[_c('div',{ref:"cc",staticClass:"arrowTip",on:{"click":_vm.toTop}},[_c('i',{staticClass:"jiantou iconfont icon-zhiding"})])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }